// extracted by mini-css-extract-plugin
export var typingIndicator = "_im-0";